/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_About_Coverage_HeadingInputs */

const ja_playdata_about_coverage_heading = /** @type {(inputs: Playdata_About_Coverage_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データ収集の対象となる大会・イベントの種類`)
};

const en_playdata_about_coverage_heading = /** @type {(inputs: Playdata_About_Coverage_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About Report Data`)
};

/**
* | output |
* | --- |
* | "About Report Data" |
*
* @param {Playdata_About_Coverage_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_about_coverage_heading = /** @type {((inputs?: Playdata_About_Coverage_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_About_Coverage_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_about_coverage_heading(inputs)
	return en_playdata_about_coverage_heading(inputs)
});